<template>
  <div class="settingLanguage">
    <q-btn
      class="fixeBtn border-radius-8"
      color="white"
      no-caps
      outline
      @click="dialog = true"
    >
      <q-icon class="left" size="12px" name="font:dm-diqiu" />
      <span class="font-size-12">{{ languageName || '' }}</span>
      <q-icon class="right" size="18px" name="font:dm-down" />
    </q-btn>
    <q-dialog v-model="dialog" position="bottom" @hide="hideDialog">
      <q-card class="no-border-radius">
        <div class="header">
          <span class="font-size-14 text-weight-bolder">
            {{ $t('home.language') }}
          </span>
          <q-btn v-close-popup size="xs" unelevated round flat>
            <q-icon size="16px" name="font:dm-close" />
          </q-btn>
        </div>
        <q-card-section class="q-py-none">
          <q-item
            v-for="item in options"
            :key="item.value"
            tag="label"
            class="no-padding"
          >
            <q-item-section class="no-margin">
              <q-item-label>
                <q-radio v-model="locale" :val="item.value" />
                <span class="q-ml-xs vertical-middle font-size-16 text-black">
                  {{ item.label }}
                </span>
              </q-item-label>
            </q-item-section>
          </q-item>
        </q-card-section>
        <MButton
          v-close-popup
          bold
          class="btn"
          primary
          @click="settingLanguage"
        >
          {{ $t('home.save') }}
        </MButton>
      </q-card>
    </q-dialog>
  </div>
</template>

<script>
import MButton from 'src/components/MButton/index.vue';
import { loadingMixin } from '../../mixin/loadingMixin';
import { getStoreInfo } from '../../../api/home';

export default {
  components: { MButton },
  mixins: [loadingMixin],
  data() {
    return {
      dialog: false,
      // name: '',
      locale: '',
      options: [
        { label: 'Indonesia', value: 'id-ID' },
        { label: 'English', value: 'en-US' },
      ],
    };
  },
  computed: {
    languageName() {
      const [curr] = this.options.filter(
        (item) => item.value === (this.locale || this.language),
      );
      if (curr) {
        return curr.label;
      }
      return '';
    },
  },
  // watch: {
  //   language(val) {
  //     this.locale = val;
  //     const [curr] = this.options.filter(item => item.value === this.locale);
  //     this.name = curr[0].label;
  //   },
  // },
  mounted() {
    this.locale = this.language;
    this.$q.cookies.set('BUYER_LANG', this.locale);
    setTimeout(() => {
      this.refreshStore();
    }, 500);
  },
  methods: {
    hideDialog() {
      if (this.locale !== this.language) {
        this.locale = this.language;
      }
    },
    settingLanguage() {
      this.$store.commit('Menu/updateLanguage', this.locale);
      this.$q.cookies.set('BUYER_LANG', this.locale);
      this.$i18n.locale = this.locale;
      this.refreshStore();
    },
    flag(val) {
      return this.locale === val ? 'font:dm-radio-active' : 'font:dm-radio';
    },
    async refreshStore() {
      try {
        this.loading('refresh_store');
        await getStoreInfo().then((res) => {
          this.$store.commit('prefetch/updateStoreInfo', res.data);
        });
      } catch (_) {
        this.hide('refresh_store');
      } finally {
        this.hide('refresh_store');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.settingLanguage {
  position: absolute;
  top: 24px;
  right: 24px;
  z-index: 10;
  border-radius: 8px;
  :deep(.fixeBtn) {
    width: 115px;
    height: 36px;
    .q-btn__wrapper {
      padding: 0 8px 0 10px;
      &:before {
        border-color: #d1d5db;
        background: #ffffff;
      }
      .q-btn__content {
        display: inline-block;
        text-align: left;
        line-height: 34px;
        .q-icon {
          margin: 0;
          color: #9ca3af;
        }
        span,
        i {
          vertical-align: middle;
        }
        span {
          margin-left: 6px;
          color: $black;
        }
        .right {
          float: right;
          margin-top: 10px;
        }
      }
    }
  }
}
.btn {
  margin: 8px auto;
  width: 92%;
}
:deep(.q-card__section--vert) {
  padding: 4px 8px;
}
:deep(.header) {
  display: flex;
  padding: 12px 16px;
  justify-content: space-between;
}
</style>
